import React from 'react';
import PropTypes from 'prop-types';

import TemplateVariable from './TemplateVariableTypes';

const ComplexFlow = (props) => {
  const {
    templateVariableValues,
    templatePage,
    updateVariableValues,
    hasSchedulingPerk,
  } = props;

  return (
    <div className="flex flex-direction--column w-full padding-horizontal-none">
      {templateVariableValues.map((currentGroup, questionGroupIndex) => {
        const groupQuestions = currentGroup.variableQuestions;
        if (questionGroupIndex === templatePage) {
          return (
            <React.Fragment key={currentGroup.order}>
              <div className="margin-btm-sm">
                <h3 className="font-bold margin-btm-sm color-grey-10 text-size-h2">
                  <span>{currentGroup.title}</span>
                </h3>
                {currentGroup.description && (
                  <p className="text-size-primary margin-top-none color-grey-9">
                    <span>{currentGroup.description}</span>
                  </p>
                )}
              </div>
              {groupQuestions.map((question, questionIndex) => (
                <div key={question.name}>
                  <TemplateVariable
                    question={question}
                    questionIndex={questionIndex}
                    questionGroupIndex={questionGroupIndex}
                    updateVariableValues={updateVariableValues}
                    skipTopMargin={questionIndex === 0}
                    hasSchedulingPerk={hasSchedulingPerk}
                  />
                </div>
              ))}
            </React.Fragment>
          );
        }
        return null;
      })}
    </div>
  );
};

ComplexFlow.propTypes = {
  templateVariableValues: PropTypes.array,
  templatePage: PropTypes.number,
  updateVariableValues: PropTypes.func,
  hasSchedulingPerk: PropTypes.bool,
};

export default ComplexFlow;
